export default __webpack_public_path__ + "static/media/yinsong.f39de5b2.jpg";